import React, { useLayoutEffect, useEffect ,useState,useRef} from "react";
import styled from "styled-components";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { CSSTransition } from 'react-transition-group';
import { Collapse } from 'antd';
import { useParams } from "react-router-dom";

import Flex from "../../core/Flex";
import useAdminApplicationDetailStore from "../../../store/useAdminApplicationDetailStore";
import useViewStore from "../../../store/useViewStore";
import useAuthAdminStore from "../../../store/useAuthAdminStore";
import FormHeader from "../../form/FormHeader";
import FormTitle from "../../form/FormTitle";
import FormText from "../../form/FormText";
import FormButton from "../../form/FormButton";
import FormButtonPrimary from "../../form/FormButtonPrimary";
import FormButtonSecondary from "../../form/FormButtonSecondary";
import FormButtonDanger from "../../form/FormButtonDanger";
import withErrorHandling from "../../../function/withErrorHandling";

function TaskListBar() {
  const { t } = useTranslation();
  const { data, isTaskListOpen, setIsTaskListOpen, setSelectedTab } = useAdminApplicationDetailStore();
  const { taskList_activeKey, setTaskList_activeKey } = useAdminApplicationDetailStore();
  const { openContentDeclineModal,openContentDeclineFirstModal, openContentApprove1Modal, openContentApprove2Modal, openContentSUPPLEModal, openContentClaimRequest, openContentScheduledChargeback, admChgPreAuthFormStatus, admGetPreAuthForm } = useAdminApplicationDetailStore();

  // For STP
  const { contentApprove1_TreatmentType_List, setContentApprove1_TreatmentType } = useAdminApplicationDetailStore();
  const { contentApprove1_ClassificationOfSurgery_List, setContentApprove1_ClassificationOfSurgery } = useAdminApplicationDetailStore();
  const { setContentApprove1_ICD, setContentApprove1_ICD_code } = useAdminApplicationDetailStore();
  const { setContentApprove1_Remarks } = useAdminApplicationDetailStore();
  const { setContentApprove1_RemarksText } = useAdminApplicationDetailStore();
  const { setContentApprove1_savingAmount } = useAdminApplicationDetailStore();

  const { contentApprove2_Operation_List, setContentApprove2_Operation } = useAdminApplicationDetailStore();
  const { contentApprove2_Accommodation_List, setContentApprove2_Accommodation } = useAdminApplicationDetailStore();
  const { contentApprove2_BenefitType_List, setContentApprove2_BenefitType } = useAdminApplicationDetailStore();
  const { setContentApprove2_lumpSumBenefitAmount } = useAdminApplicationDetailStore();

  const { setContentBasicHospitalAndSurgicalBenefits_surgeon_fee, setContentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee, setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_operating_theatre, setContentBasicHospitalAndSurgicalBenefits_operating_theatre_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges, setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit, setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_cnofdays } = useAdminApplicationDetailStore();
  const { setContentBasicHospitalAndSurgicalBenefits_room_and_board, setContentBasicHospitalAndSurgicalBenefits_room_and_board_remark } = useAdminApplicationDetailStore();

  const { setContentSMMBenefit_fillInSMMDetail, setContentSMMBenefit_deductibleAmount, setContentSMMBenefit_reimbursementPercentage, setContentSMMBenefit_overallLimitType, setContentSMMBenefit_overallLimit } = useAdminApplicationDetailStore();
  const { setContentSMMBenefit_remarks, setContentSMMBenefit_remarksText } = useAdminApplicationDetailStore();
  const { contentComposeEmail_Reason_List, contentSMMBenefit_overallLimit_type_list } = useAdminApplicationDetailStore();

  const { isDesktopView } = useViewStore();
  const { aid } = useParams();
  const { isCSTeam } = useAuthAdminStore();

  const updateStatus = withErrorHandling(admChgPreAuthFormStatus);
  const loadAdmGetPreAuthForm = withErrorHandling(admGetPreAuthForm);

  const items = [
    {
      key: '1',
      showArrow: false,
      // collapsible: "disabled",
      label: <Flex justifyContent={"space-between"}>
        <FormTitle style={{ color: taskList_activeKey === "1" && data?.form?.flowType !== "STP" ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-30)" }}>1. {t("translation:admin.taskList.step1.title")}</FormTitle>
        <Icon src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} alt="ok" />
      </Flex>,
      children: <>
        <p>{t("translation:admin.taskList.step1.content")}</p>
        <FormButtonPrimary style={{ width: "100%" }} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => {
          setSelectedTab("details");
          setTaskList_activeKey("2");
        }}>{t("translation:admin.taskList.step1.check")}</FormButtonPrimary>
      </>,
    },
    {
      key: '2',
      showArrow: false,
      label: <Flex justifyContent={"space-between"}>
        <FormTitle style={{ color: taskList_activeKey === "2" || data?.form?.flowType === "STP" ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-30)" }}>{data?.form?.flowType === "STP" ? "1." : "2."} {t("translation:admin.taskList.step2.title")}</FormTitle>
        <Icon src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} alt="ok" />
      </Flex>,
      children: <>
        <p>{t("translation:admin.taskList.step2.content")}</p>
        <FormButtonPrimary disabled={isCSTeam()} bgColor={"var(--aia-bx-green-60)"} bgColorHover={"var(--aia-bx-green-50)"} style={{ width: "100%", marginBottom: 8 }} onClick={isCSTeam() ? null : () => {
          if (data?.form?.flowType === "LOG") {
            openContentApprove1Modal(aid, { value: "APPROVELOG" });
          } else if (data?.form?.flowType === "STP") {
            // ContentApprove1
            setContentApprove1_TreatmentType(contentApprove1_TreatmentType_List.find(item => item.value === data?.claim?.treatmentType));
            setContentApprove1_ClassificationOfSurgery(contentApprove1_ClassificationOfSurgery_List.find(item => item.value === data?.claim?.classificationSurgery));
            setContentApprove1_ICD(data?.claim?.ICDCode || "");
            setContentApprove1_ICD_code(data?.claim?.ICDCodeList?.split(",") || []);
            setContentApprove1_Remarks(data?.claim?.treatmentRemarkOption?.split(",") || []);
            setContentApprove1_RemarksText(data?.claim?.treatmentRemark || "");
            setContentApprove1_savingAmount(data?.claim?.saveAmt || "");

            // ContentApprove2
            setContentApprove2_Operation(contentApprove2_Operation_List.find(item => item.value === data?.claim?.operationClassified));
            setContentApprove2_Accommodation(contentApprove2_Accommodation_List.find(item => item.value === data?.claim?.lvOfAccommodation));
            setContentApprove2_BenefitType(contentApprove2_BenefitType_List.find(item => item.value === data?.claim?.benefitType));
            setContentApprove2_lumpSumBenefitAmount(data?.claim?.lumpSumAmt || "");

            // ContentBasicHospitalAndSurgicalBenefits
            setContentBasicHospitalAndSurgicalBenefits_surgeon_fee(data?.claim?.surgeonFee);
            setContentBasicHospitalAndSurgicalBenefits_surgeon_fee_remark(data?.claim?.surgeonFeeRemark || "");
            setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee(data?.claim?.anaesthetistFee);
            setContentBasicHospitalAndSurgicalBenefits_anaesthetist_fee_remark(data?.claim?.anaesthetistFeeRemark || "");
            setContentBasicHospitalAndSurgicalBenefits_operating_theatre(data?.claim?.operatingTheatreFee);
            setContentBasicHospitalAndSurgicalBenefits_operating_theatre_remark(data?.claim?.operatingTheatreFeeRemark || "");
            setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges(data?.claim?.miscellaneousHospitalCharge);
            setContentBasicHospitalAndSurgicalBenefits_miscellaneous_hospital_charges_remark(data?.claim?.miscellaneousHospitalChargeRemark || "");
            setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit(data?.claim?.physicianFee);
            setContentBasicHospitalAndSurgicalBenefits_physician_hospital_visit_remark(data?.claim?.physicianFeeRemark || "");
            setContentBasicHospitalAndSurgicalBenefits_cnofdays(data?.claim?.cnofdays);
            setContentBasicHospitalAndSurgicalBenefits_room_and_board(data?.claim?.roomFee);
            setContentBasicHospitalAndSurgicalBenefits_room_and_board_remark(data?.claim?.roomFeeRemark || "");

            // ContentSMMBenefit
            setContentSMMBenefit_fillInSMMDetail(data?.claim?.SMMDetail === "Y" ? true : false);
            setContentSMMBenefit_deductibleAmount(data?.claim?.deductAmt || "");
            setContentSMMBenefit_reimbursementPercentage(data?.claim?.reimbursementPercent || "");
            setContentSMMBenefit_overallLimitType(contentSMMBenefit_overallLimit_type_list.find(item => item.value === data?.claim?.contentSMMBenefit_overallLimit_type));
            setContentSMMBenefit_overallLimit(data?.claim?.overallLimit || "");
            setContentSMMBenefit_remarks(data?.claim?.SMMRemarkOption?.split(",") || []);
            setContentSMMBenefit_remarksText(data?.claim?.SMMRemark || "");
            

            openContentApprove1Modal(aid, { value: "APPROVEPCA" });
          } else {
            openContentApprove1Modal(aid, { value: "APPROVEPCA" });
          }
        }}>{t("translation:admin.taskList.step2.approve")}</FormButtonPrimary>
        <FormButtonPrimary disabled={isCSTeam()} style={{ width: "100%", marginBottom: 8 }} onClick={isCSTeam() ? null : () => {
          openContentSUPPLEModal(aid, { value: "SUPPLE" });
        }}>{t("translation:admin.taskList.step2.supple")}</FormButtonPrimary>
        <FormButtonSecondary disabled={isCSTeam()} style={{ width: "100%", marginBottom: 8 }} onClick={isCSTeam() ? null : () => {
          openContentDeclineFirstModal(aid, { value: "DECLINED" });
        }}>{t("translation:admin.taskList.step2.decline")}</FormButtonSecondary>

        {
          data?.form?.flowType === "LOG" &&
          <FormButtonSecondary disabled={isCSTeam()} style={{ width: "100%" }} onClick={isCSTeam() ? null : () => {
            openContentApprove1Modal(aid, { value: "CHGTOPCA" });
          }}>{t("translation:admin.taskList.step2.chgToPCA")}</FormButtonSecondary>
        }

        {
          data?.form?.flowType === "PCA" &&
          <FormButtonSecondary disabled={isCSTeam()} style={{ width: "100%" }} onClick={isCSTeam() ? null : () => {
            openContentApprove1Modal(aid, { value: "CHGTOLOG" });
          }}>{t("translation:admin.taskList.step2.chgToLOG")}</FormButtonSecondary>
        }
      </>,
    },
    {
      key: '3',
      showArrow: false,
      label: <Flex justifyContent={"space-between"}>
        <FormTitle style={{ color: taskList_activeKey === "3" ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-30)" }}>2.1 {t("translation:admin.taskList.step2_1.title")}</FormTitle>
        <Icon src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} alt="ok" />
      </Flex>,
      children: <Flex direction={"column"}>
        <p>{t("translation:admin.taskList.step2_1.content")}</p>
        <FormButtonPrimary style={{ width: "100%", marginBottom: 8 }} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => {
          setSelectedTab("documents");
        }}>{t("translation:admin.taskList.step2_1.upload")}</FormButtonPrimary>
        <FormButtonSecondary style={{ width: "100%", marginBottom: 8 }} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => {
          setSelectedTab("details");
        }}>{t("translation:admin.taskList.step2_1.edit")}</FormButtonSecondary>
        <a href="javascript: void(0)" style={{ textDecoration: "underline", color: "var(--aia-bx-gray)" }} onClick={() => {
          updateStatus(aid, { value: "REVIEW" }).then(() => {
            loadAdmGetPreAuthForm(aid);
          });
        }}>
          {t("translation:admin.taskList.step2_1.next")}
        </a>
      </Flex>,
    },
    {
      key: '4',
      showArrow: false,
      label: <Flex justifyContent={"space-between"}>
        <FormTitle style={{ color: taskList_activeKey === "4" ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-30)" }}>2.2 {t("translation:admin.taskList.step2_2.title")}</FormTitle>
        <Icon src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} alt="ok" />
      </Flex>,
      children: <>
        <p>{t("translation:admin.taskList.step2_2.content")}</p>
        <FormButtonPrimary style={{ width: "100%", marginBottom: 8 }} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => {
          setSelectedTab("documents");
          setTaskList_activeKey("2");
        }}>{t("translation:admin.taskList.step2_2.check")}</FormButtonPrimary>
      </>,
    },
    {
      key: '5',
      showArrow: false,
      label: <Flex justifyContent={"space-between"}>
        <FormTitle style={{ color: taskList_activeKey === "5" ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-30)" }}>3. {t("translation:admin.taskList.step3.title")}</FormTitle>
        <Icon src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} alt="ok" />
      </Flex>,
      children: <>
        <p>{t("translation:admin.taskList.step3.content")}</p>
        <FormButtonPrimary style={{ width: "100%", marginBottom: 8 }} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => {
          openContentClaimRequest(aid, { value: "PENDCHARGE" });
        }}>{t("translation:admin.taskList.step3.confirm_claim")}</FormButtonPrimary>
      </>,
    },
    {
      key: '6',
      showArrow: false,
      label: <Flex justifyContent={"space-between"}>
        <FormTitle style={{ color: taskList_activeKey === "6" ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-30)" }}>4. {t("translation:admin.taskList.step4.title")}</FormTitle>
        <Icon src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} alt="ok" />
      </Flex>,
      children: <>
        <p>{t("translation:admin.taskList.step4.content")}</p>
        <FormButtonDanger style={{ width: "100%", marginBottom: 8 }} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => {
          openContentScheduledChargeback(aid, { value: "SCHCHARGE" });
        }}>{t("translation:admin.taskList.step4.chargeback")}</FormButtonDanger>
      </>,
    },
    {
      key: '7',
      showArrow: false,
      label: <Flex justifyContent={"space-between"}>
        <FormTitle style={{ color: taskList_activeKey === "7" ? "var(--aia-bx-dark-blue)" : "var(--aia-bx-grey-30)" }}>5. {t("translation:admin.taskList.step5.title")}</FormTitle>
        <Icon src={`${process.env.PUBLIC_URL}/images/circle-check.svg`} alt="ok" />
      </Flex>,
      children: <>
        <p>{t("translation:admin.taskList.step5.content")}</p>
        <FormButtonPrimary bgColor={"var(--aia-bx-green-60)"} bgColorHover={"var(--aia-bx-green-50)"} style={{ width: "100%", marginBottom: 8 }} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => {
          updateStatus(aid, { value: "CLAIMSETTLE" }).then(() => {
            loadAdmGetPreAuthForm(aid);
          });
        }}>{t("translation:admin.taskList.step5.chargeback")}</FormButtonPrimary>
      </>,
    },
  ].filter(item => data?.form?.flowType === "LOG" || (data?.form?.flowType !== "LOG" && data?.form?.flowType !== "STP" && item.key < 5) || (data?.form?.flowType === "STP" && item.key === "2"));
 
  // task bar list 的状态选择，如果是拒绝（Decline）后，不允许再处理。
  useEffect(() => {
    setTaskList_activeKey("");

    switch (data?.form?.intstatus) {
      case "NEW":
        setTaskList_activeKey("1");
        break;

      case "SUPPLE":
        setTaskList_activeKey("3");
        break;

      case "REVIEW":
        setTaskList_activeKey("4");
        break;

      case "APPROVELOG":
        setTaskList_activeKey("5");
        break;

      case "APPROVEPCA":
        setTaskList_activeKey("");
        break;

      case "DECLINED":
        setTaskList_activeKey("");
        break;

      case "PENDCHARGE":
        setTaskList_activeKey("6");
        break;

      case "SCHCHARGE":
        setTaskList_activeKey("");
        break;

      case "OUTCHARGE":
        setTaskList_activeKey("6");
        break;

      case "CHARGESETTLE":
        setTaskList_activeKey("7");
        break;

      case "CLAIMSETTLE":
        setTaskList_activeKey("");
        break;
    }
  }, [data?.form?.intstatus]);
//业务需求:  要禁用decline   超过14天的decline cancel要隐藏。禁止操作了。  
const [isDeclineOrCancelOver14Days,setIsDeclineOrCancelOver14Days]=useState(false)
const timerRef = useRef(null);
 // 计时器逻辑
useEffect(() => {
  if (!data?.form?.intstatus || !data?.form?.moddt || isDeclineOrCancelOver14Days) return;
//   if(['CANCELLED','DECLINED'].includes(data?.form?.intstatus)===false  && data?.form?.flowType!=='CHGTOPCA'){
//     //两个都false的时候，退出
//     return 
//  }

  const deadline = new Date(data?.form?.moddt?.replace(" ", "T"));
  const deadlinePlus14Days = new Date(deadline.getTime() + 14 * 24 * 60 * 60 * 1000);
  timerRef.current = setInterval(() => {
    const now = new Date(); 
    if (now >= deadlinePlus14Days) { // 超过拒绝、取消、CHGTOPCA的14天
      if(['CANCELLED','DECLINED'].includes(data?.form?.intstatus) ||data?.form?.flowType==='CHGTOPCA'){
        setIsDeclineOrCancelOver14Days(true)
        setTaskList_activeKey("");
      } 
      clearInterval(timerRef.current); 
    }
  }, 1000);

  return () => {
    clearInterval(timerRef.current); // 清除定时器，防止内存泄漏
  };
}, [data?.form?.intstatus,data?.form?.moddt,data?.form?.flowType]); //  依赖 deadline，因为它是异步获取的

  return (
    <CSSTransition
      in={isTaskListOpen}
      timeout={250}
      classNames="taskList"
    >
      <TaskList $isTaskListOpen={isTaskListOpen} $isDesktopView={isDesktopView} onClick={() => {
        if (!isTaskListOpen) {
          setIsTaskListOpen(true);
        }
      }}>
        {
          !isTaskListOpen && <Flex direction={"column"} justifyContent={"center"} gap={16}>
            <TaskListText>{t("translation:admin.taskList.title")}</TaskListText>
            <Icon src={`${process.env.PUBLIC_URL}/images/chevron-em-d.png`} alt="icon" />
          </Flex>
        }

        {
          isTaskListOpen && <TaskListContent>
            <Flex justifyContent={"space-between"} style={{ width: "100%" }}>
              <FormHeader style={{ margin: 0 }}>{t("translation:admin.taskList.title")}</FormHeader>
              <FormButton onClick={() => {
                setIsTaskListOpen(false);
              }}>
                <Icon src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="close" />
              </FormButton>
            </Flex>
            <div style={{
              height: "calc(100vh - 160px)",
              overflow: "auto",
              width: "100%"
            }}>
              <Collapse
                // bordered={false}
                collapsible={"disabled"}
                activeKey={data?.form?.flowType === "STP" ? "2" : taskList_activeKey}
                style={{
                  background: "var(--aia-bx-white)",
                  width: "100%"
                }}
                items={items}
              />
            </div>
          </TaskListContent>
        }
      </TaskList>
    </CSSTransition>
  );
}

const TaskList = styled(Flex)`
  flex-basis: auto;
  width: 400px;
  height: 100%;
  flex-direction: column;
  background: var(--aia-bx-white);
  
  ${(props) => props.$isTaskListOpen ? `
    justify-content: flex-start;
  `: `
    justify-content: center;
    cursor: pointer;
    width: 60px;
    transition: width 0.25s ease-in-out;
    background: linear-gradient(to bottom, #018dcf, #04afff, #4bc0e9) !important;

    &:hover {
      background: linear-gradient(to bottom, #2596cb, #2bbbff, #4fc2e9) !important;
      border-color: var(--aia-bx-blue-2);
      box-shadow: 0px 0px 0.5rem 0px rgba(2, 114, 174, 0.2);
    }
  `}

  ${(props) => !props.$isDesktopView && `display: none;`}
`;

const TaskListText = styled.span`
  display: inline-block;
  color: white;
  font-size: 28px;
  font-weight: bold;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
`;

const Icon = styled.img`
  width: 30px;
  height: 30px;
`;

const TaskListContent = styled(Flex)`
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  width: 100%;
`;

export default TaskListBar;